import dropdown from './components/dropdown/dropdown.component';
import modal from './components/modal/modal.component';

import charCount from './directives/charCount';
import elastic from './directives/elastic';
import fileSelectionChange from './directives/fileSelectionChange';
import dropZone from './directives/dropZone';

import AppUtils from './services/appUtils';
import CampaignsService from './services/campaigns';
import CustomerService from './services/customer';
import ErrorHandler from './services/errorHandler';
import FileTypes from './services/fileTypes';
import FileUtils from './services/fileUtils';
import LocationUtils from './services/locationUtils';
import CCASession from './services/ccaSession';
import contentCreatorAdminAPI from './services/contentCreatorAdminAPI';
import WaitForExternalLibrary from './services/waitForExternalLibrary';

/**
 * @ngdoc overview
 * @name common
 * @description
 * This is the application common module.
 */
const commonModule = angular.module('common', [])
.service('appUtils', AppUtils)
.service('campaignsService', CampaignsService)
.service('customerService', CustomerService)
.service('ccaSession', CCASession)
.service('contentCreatorAdminAPI', contentCreatorAdminAPI)
.service('errorHandler', ErrorHandler)
.service('fileTypes', FileTypes)
.service('fileUtils', FileUtils)
.service('waitForExternalLibrary', WaitForExternalLibrary)
.factory('locationUtils', LocationUtils)
.component('dropdown', dropdown)
.component('modal', modal)
.directive('charCount', charCount)
.directive('elastic', elastic)
.directive('fileSelectionChange', fileSelectionChange)
.directive('dropZone', dropZone);

export default commonModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/index.js